/* TissueMotif homepage logo choreography. No dependencies or network requests. */
(()=>{'use strict';
if(window.TMLogoMotion39){window.TMLogoMotion39.mount(document);return;}

/* Pure choreography in a logical coordinate space; the canvas has no background. */
const COUNT=48, DURATION=32;
const clamp=(n,a=0,b=1)=>Math.max(a,Math.min(b,n));
const lerp=(a,b,t)=>a+(b-a)*t;
const smooth=t=>{t=clamp(t);return t*t*t*(t*(t*6-15)+10)};
const ease=t=>1-Math.pow(1-clamp(t),4);
const pose=(x=0,y=0,s=1,r=0,a=1)=>({x,y,s,r,a});
function makeLayout(portrait){
  const cols=portrait?6:8,rows=COUNT/cols,dx=portrait?91:104,dy=portrait?91:89;
  const cells=Array.from({length:COUNT},(_,i)=>{const c=i%cols,r=Math.floor(i/cols);return {c,r,x:(c-(cols-1)/2)*dx,y:(r-(rows-1)/2)*dy}});
  cells.sort((a,b)=>Math.hypot(a.x,a.y)-Math.hypot(b.x,b.y)||Math.atan2(a.y,a.x)-Math.atan2(b.y,b.x));
  return {portrait,cols,rows,dx,dy,cells,width:portrait?700:900,height:portrait?960:720};
}
function shape(kind,i,t,L){
  const c=L.cells[i],drift=Math.sin(t*.8+i*.3)*1.2;
  if(kind==='grid')return pose(c.x,c.y+drift,1,0,1);
  if(kind==='offset')return pose(c.x*.91+(c.r%2?1:-1)*L.dx*.22,c.y*.94+drift,1,0,1);
  if(kind==='ring'){
    const ring=i<8?0:i<24?1:2,n=[8,16,24][ring],j=i-[0,8,24][ring];
    const radius=[82,170,258][ring]*(L.portrait?1.08:1);
    const angle=j/n*Math.PI*2-Math.PI/2+(t-13)*[.075,-.045,.035][ring];
    return pose(Math.cos(angle)*radius,Math.sin(angle)*radius,ring===0?1.12:.92,Math.sin(angle)*.06,1);
  }
  if(kind==='diamond'){
    const angle=Math.PI/5,scale=L.portrait?.77:.82,x=c.x*scale,y=c.y*scale;
    return pose(x*Math.cos(angle)-y*Math.sin(angle),x*Math.sin(angle)+y*Math.cos(angle),.95,Math.PI/5,1);
  }
  const phase=c.c*.67+c.r*.38-t*.85,z=Math.sin(phase),s=.88+(z+1)*.115;
  return pose(c.x+Math.cos(phase)*14,c.y+Math.sin(phase)*34,s,Math.sin(phase)*.12,.60+(z+1)*.2);
}
function morph(a,b,u,i,bend=20){
  const e=smooth(u),arc=Math.sin(Math.PI*e)*bend*((i%2)*2-1);
  const dx=b.x-a.x,dy=b.y-a.y,len=Math.hypot(dx,dy)||1;
  return pose(lerp(a.x,b.x,e)-dy/len*arc,lerp(a.y,b.y,e)+dx/len*arc,lerp(a.s,b.s,e),lerp(a.r,b.r,e),lerp(a.a,b.a,e));
}
function sample(i,time,L){
  const t=((time%DURATION)+DURATION)%DURATION;
  if(t<6){
    const target=shape('grid',i,t,L),start=i===0?1.15:1.15+i*.074,u=(t-start)/1.5;
    if(i===0&&u<=0)return pose(0,0,2.5,0,1);
    if(u<=0)return pose(0,0,.3,0,0);
    const q=ease(u),angle=Math.atan2(target.y,target.x),arc=Math.sin(Math.PI*q)*(18+i*.32);
    return pose(target.x*q-Math.sin(angle)*arc,target.y*q+Math.cos(angle)*arc,lerp(i===0?2.5:.55,1,q),Math.sin(Math.PI*q)*.13*(i%2?1:-1),i===0?1:smooth(u*4));
  }
  const stagger=(i%8)*.047;
  if(t<9)return shape('grid',i,t,L);
  if(t<13)return morph(shape('grid',i,t,L),shape('offset',i,t,L),(t-9-stagger)/2.2,i,13);
  if(t<18)return morph(shape('offset',i,t,L),shape('ring',i,t,L),(t-13-stagger)/2.65,i,44);
  if(t<22)return morph(shape('ring',i,t,L),shape('diamond',i,t,L),(t-18-stagger)/2.5,i,38);
  if(t<26)return morph(shape('diamond',i,t,L),shape('wave',i,t,L),(t-22-stagger)/2.4,i,28);
  const last=shape('wave',i,26,L);
  if(i===0)return morph(last,pose(0,0,2.5,0,1),(t-27.6)/3.3,0,20);
  const start=26+(COUNT-1-i)*.055,u=(t-start)/2;
  const p=morph(last,pose(0,0,.65,0,0),u,i,38);
  p.a=last.a*(1-smooth((clamp(u)-.45)/.55));return p;
}

const instances=new Map();
function init(root){
  if(instances.has(root))return;
  const canvas=root.querySelector('.tm-sh__motion-canvas'),stage=root.querySelector('.tm-sh__motion-stage'),toggle=root.querySelector('[data-motion-toggle]');
  if(!canvas||!stage||!toggle||!window.Path2D||!window.ResizeObserver)return;
  const ctx=canvas.getContext('2d');if(!ctx)return;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const mark=new Path2D('M -12 12 L -12 -10 L 0 2 L 12 -10 L 12 12 M -8 -12 L 0 -4 L 8 -12');
  const crown=new Path2D('M 0 -30 L 3 -26 L 0 -27 L -3 -26 Z');
  const highlights=new Set([3,17,29,41]);
  let W=1,H=1,dpr=1,scale=1,L=makeLayout(false),playhead=reduced.matches?7:0,playing=!reduced.matches,inView=false,last=0,raf=0,disposed=false;
  // Four soft, local light accents; the transparent stage itself never glows.
  const glows=['#b3dce9','#c5b7ef'].map(color=>{
    const sprite=document.createElement('canvas');sprite.width=sprite.height=160;
    const g=sprite.getContext('2d'),light=g.createRadialGradient(80,80,8,80,80,76);
    light.addColorStop(0,color+'22');light.addColorStop(.38,color+'18');light.addColorStop(1,color+'00');
    g.fillStyle=light;g.fillRect(0,0,160,160);return sprite;
  });
  function logo(p,i,t,alpha=1,ghost=false){
    if(p.a<.005)return;
    ctx.save();ctx.translate(p.x,p.y);ctx.rotate(p.r);ctx.scale(p.s,p.s);ctx.globalAlpha=p.a*alpha;
    const lit=!ghost&&(highlights.has(i)||(i===0&&p.s>1.5));
    const intensity=lit?.28+.72*(.5+.5*Math.sin(t*(Math.PI*8/DURATION)+i*1.7)):0;
    if(lit){ctx.globalAlpha=p.a*intensity;ctx.drawImage(glows[i%2],-48,-48,96,96);ctx.globalAlpha=p.a;}
    const metal=ctx.createLinearGradient(-24,-28,23,27);
    metal.addColorStop(0,lit?'#bed2e8':'#8d95b0');metal.addColorStop(.28,'#f6f4ff');metal.addColorStop(.5,lit?'#e2ddff':'#c9c5e4');metal.addColorStop(.72,lit?'#b6d6e0':'#8f9da9');metal.addColorStop(1,'#ebf3f5');
    ctx.strokeStyle=metal;ctx.fillStyle=metal;ctx.lineWidth=.85;
    ctx.beginPath();ctx.arc(0,0,23,0,Math.PI*2);ctx.stroke();ctx.lineWidth=1.65;ctx.lineCap='round';ctx.lineJoin='round';ctx.stroke(mark);ctx.fill(crown);
    if(lit){
      ctx.globalAlpha=p.a*intensity*.8;ctx.strokeStyle=i%2?'#e6d9ff':'#d7f5ff';ctx.shadowColor=i%2?'#c4adff':'#a4dff3';ctx.shadowBlur=8*scale*dpr;
      ctx.lineWidth=1.3;const angle=t*(Math.PI*4/DURATION)+i;ctx.beginPath();ctx.arc(0,0,23,angle,angle+.7);ctx.stroke();
    }
    ctx.restore();
  }
  function draw(){
    ctx.setTransform(dpr,0,0,dpr,0,0);ctx.clearRect(0,0,W,H);ctx.translate(W/2,H/2);ctx.scale(scale,scale);
    for(let i=0;i<COUNT;i++){
      const p=sample(i,playhead,L),old=sample(i,playhead-.1,L),speed=Math.hypot(p.x-old.x,p.y-old.y);
      if(speed>9&&p.a>.12)for(let j=3;j>=1;j--)logo(sample(i,playhead-j*.035,L),i,playhead,.035*(4-j),true);
      logo(p,i,playhead);
    }
  }
  function resize(){
    if(disposed)return;const r=stage.getBoundingClientRect();W=Math.max(1,r.width);H=Math.max(1,r.height);dpr=Math.min(devicePixelRatio||1,2);
    canvas.width=Math.round(W*dpr);canvas.height=Math.round(H*dpr);L=makeLayout(W/H<.9);scale=Math.min(W/L.width,H/L.height);draw();
    root.dataset.motionReady='true';
  }
  function tick(now){
    raf=0;if(disposed||!playing||document.hidden||!inView)return;
    if(last)playhead=(playhead+Math.min((now-last)/1000,.05))%DURATION;
    last=now;draw();raf=requestAnimationFrame(tick);
  }
  function sync(){
    cancelAnimationFrame(raf);raf=0;last=0;
    root.dataset.motion=playing?'playing':'paused';
    const label=toggle.dataset[playing?'labelPause':'labelPlay'];toggle.setAttribute('aria-label',label);toggle.title=label;
    if(playing&&!document.hidden&&inView)raf=requestAnimationFrame(tick);else if(inView)draw();
  }
  function onToggle(){playing=!playing;sync();}
  function onPreference(){playing=!reduced.matches;if(reduced.matches)playhead=7;sync();}
  const ro=new ResizeObserver(resize);ro.observe(stage);
  const io=window.IntersectionObserver?new IntersectionObserver(entries=>{inView=entries.some(e=>e.isIntersecting);sync();},{threshold:0}):null;
  if(io)io.observe(root);else inView=true;
  toggle.addEventListener('click',onToggle);document.addEventListener('visibilitychange',sync);reduced.addEventListener('change',onPreference);
  toggle.hidden=false;resize();sync();
  instances.set(root,()=>{disposed=true;cancelAnimationFrame(raf);ro.disconnect();if(io)io.disconnect();toggle.removeEventListener('click',onToggle);document.removeEventListener('visibilitychange',sync);reduced.removeEventListener('change',onPreference);toggle.hidden=true;delete root.dataset.motionReady;instances.delete(root);});
}
function mount(scope){if(scope.matches?.('[data-tm-studio-hero]'))init(scope);scope.querySelectorAll('[data-tm-studio-hero]').forEach(init);}
window.TMLogoMotion39={mount};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});else mount(document);
document.addEventListener('shopify:section:load',e=>mount(e.target));
document.addEventListener('shopify:section:unload',e=>{for(const [root,dispose] of instances)if(e.target.contains(root))dispose();});
})();
